/**
 * File slider-strip.js.
 * Script for initializing a slider strip for blog home and post slider section
 */
function initSlider(slider) {
  const $ = jQuery;
  const row = slider.getAttribute('data-row');
  const show = slider.hasAttribute('data-slides') ? slider.getAttribute('data-slides') : 3;
  const useDots = slider.hasAttribute('data-dots') ? slider.getAttribute('data-dots') : false;
  const mobileOnly = slider.hasAttribute('data-mobile-only') ? slider.getAttribute('data-mobile-only') : false;
  const thisSlider = $('.slider-strip--' + row);

  let slideOptions = {
    infinite: false,
    speed: 500,
    slidesToShow: show,
    slidesToScroll: 1,
    adaptiveHeight: false,
    autoplay: false,
    arrows: true,
    nextArrow: $('.category-next--' + row),
    prevArrow: $('.category-prev--' + row),
    appendDots: $('.category-dots--' + row),
    variableWidth: true,
    lazyLoad: 'anticipated',
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: show - 1,
        },
      },
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 1,
          dots: useDots ? true : false,
        },
      },
    ]
  };

  if (mobileOnly) {
    slideOptions.mobileFirst = true,
    slideOptions.responsive = [
      {
        breakpoint: 860,
        settings: 'unslick',
      },
    ];
  }

  thisSlider.slick(slideOptions);

  // reslick the slider if necessary
  $(window).on('resize', function() {
    if ($(window).width() < 860 && !thisSlider.hasClass('slick-initialized')) {
      thisSlider.slick(slideOptions);
    }
  });
}

 function sliderStrip() {
  const sliders = document.getElementsByClassName('slider-strip');

  for (var i = 0; i < sliders.length; i++) {
    // use setTimeout to initialize each slider in its own JS task to avoid long-running JS tasks
    setTimeout(initSlider, 0, sliders[i]);
  }
}

// Inits
if (typeof jQuery !== 'undefined') jQuery(function($) {
  sliderStrip();
}); 